// Progress indicator for one running Compartment Report job (see jobs.js):
// action label + current stage + percent. `queued` jobs (an ECS task can
// take a minute or two to start) show an indeterminate bar. The banner
// itself is the shared common/JobProgress (also used by Platform Report).

import React from 'react';
import SharedJobProgress from '../common/JobProgress';
import { ACTION_LABELS } from './jobs';

const humanizeStage = (stage) => (stage ? stage.replace(/_/g, ' ') : null);

const JobProgress = ({ job, label, style }) => {
  if (!job) return null;
  const queued = job.status === 'queued';
  return (
    <SharedJobProgress
      title={label || ACTION_LABELS[job.action] || 'Running job'}
      stage={queued ? 'waiting for the job to start' : humanizeStage(job.stage) || 'starting'}
      pct={job.progress_pct}
      queued={queued}
      style={style}
    />
  );
};

export default JobProgress;
